import React from 'react';
import { FieldArray, reduxForm } from 'redux-form';
import { useTranslation } from 'react-i18next';

import { CATEGORIES } from 'pages/create-activity/constants';

import {
  ExpansionPanelWrapper,
  CategoriesPrices,
  FormActionButtons
} from 'components';

import validate from './validate';
import { connect } from 'react-redux';

const initialValues = {
  daysArray: []
};

const PricesDailySchedule = ({
  handleSubmit,
  pricesDailyScheduleForm,
  setSubmitButton,
  isUpdate,
  selectedTabIndex
}) => {
  const [t] = useTranslation();

  const getAvailableCategoriesNames = index => {
    const days = [...pricesDailyScheduleForm.values.daysArray];
    const categories = days[index].categories.map(item => item.participant);
    return CATEGORIES.filter(x => !categories.includes(x));
  };

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <FieldArray
          name="daysArray"
          component={ExpansionPanelWrapper}
          isAddDeleteActions={false}
          getTitle={item => item.days.map(item => t(item)).join(', ')}
          children={(field, index) => (
            <FieldArray
              name={`${field}.categories`}
              component={CategoriesPrices}
              availableCategories={getAvailableCategoriesNames(index)}
              selectedTabIndex={selectedTabIndex}
              tabName="price"
              tabNameAll="all prices"
            />
          )}
        />
        <FormActionButtons
          cancelPath="/accommodations-and-activities"
          actionLabel="Next"
          setSubmitButton={setSubmitButton}
          isUpdate={isUpdate}
        />
      </form>
    </div>
  );
};

const mapStateToProps = state => ({
  pricesDailyScheduleForm: state.form.pricesDailyScheduleForm
});

export default reduxForm({
  form: 'pricesDailyScheduleForm',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  touchOnBlur: false,
  validate,
  initialValues
})(connect(mapStateToProps, null)(PricesDailySchedule));
